// import Immutable from 'immutable';
import {createSelector} from 'reselect';

const currentLang = (state) => state.getIn(['langue', 'locale'], 'en');

const templates = (state) => state.getIn(['langue', 'templates']);

const getMessage = (lang, template) => {
  if (!template || template.isEmpty()) {
    return {};
  }

  return template.get(lang).toJS();
};

const selector = createSelector(
  [currentLang, templates],
  getMessage
);

export default selector;



// WEBPACK FOOTER //
// ./src/store/selectors/getTemplates.js